// extracted by mini-css-extract-plugin
export default {"component":"products__component___7mAxF","warning":"products__warning___FL16V"};